import moment from 'moment-timezone'

export const unixToMomentOffset = (timezone) => (unix) => {
  return moment(unix * 1000).tz(timezone)
}
